import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PeopleDirectoryView } from "@/features/academy/components/people/people-directory-view";

export const academyPeopleRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/people",
  component: PeopleDirectoryView,
});
